












































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { MapStoreModule } from "@/store/modules/mapStore";
import { config } from "@/utils/config/config.ts";

@Component
export default class StorePopUp extends Vue {
  private slideIndex = 0;
  private collectionIndex = 0;
  private min = 0;
  private max = -1;
  private manual = 0;
  private active = 0;
  private icons = {
    close: config.appImgUrl + "images/close.png",
    left: config.appImgUrl + "images/left-arr.png",
    right: config.appImgUrl + "images/right-arr.png"
  };

  get existStores(): boolean {
    return MapStoreModule.isActiveStatus;
  }

  get mainSlide() {
    return MapStoreModule.mainSlide;
  }

  private maxScreenCollection(collection: any): number {
    if (collection.length >= 4) {
      return 4;
    }
    return collection.length;
  }

  private gridImages(controls: number) {
    const stores = MapStoreModule.stores;
    let collection;

    Object.keys(stores).forEach(i => {
      if (stores[i].active) {
        collection = stores[i].mainImageCollection;
        return collection;
      }
    });
    this.processCollections(collection);
    return collection.slice(this.min, this.max);
  }

  private calcCollection(controls: number) {
    this.manual = 0;

    if (this.active >= 0 && controls == 1) {
      this.active += controls;
    }
    if (controls == -1) {
      this.collectionIndex--;
    }
    if (controls == 1) {
      this.collectionIndex++;
    }
    this.gridImages(this.collectionIndex);
  }

  private closePopUp(): void {
    this.slideIndex = 0;
    MapStoreModule.togglePopUp(false);
  }
  private processCollections(collection: any): void {
    if (this.max == -1) {
      this.max = this.maxScreenCollection(collection);
    }
    if (this.collectionIndex < 0) {
      this.calcPositionInReverseForLastPage(collection);
      return collection.slice(this.min, this.collectionIndex);
    }
    if (this.collectionIndex < this.min) {
      this.calcPositionInReverseForPreviousPage(collection);
      return collection.slice(this.min, this.max);
    }
    if (
      this.collectionIndex < this.max &&
      this.collectionIndex < collection.length
    ) {
      this.calcPositionForNextPage();
      return collection.slice(this.min, this.max);
    }
    if (this.collectionIndex >= collection.length) {
      this.calcPositionForFirstPageInLastPage();
      return collection.slice(0, this.maxScreenCollection(collection));
    }
    //recalc collection
    this.recalcPositionsInCollection(collection);
  }

  private findMainSlideManual(index: number): void {
    //console.log(index)
    this.manual = 1;
    this.active = index;

    if (this.collectionIndex >= 4) {
      this.collectionIndex = this.min + index;
      MapStoreModule.findMainSlide(this.collectionIndex);
      return;
    }
    this.collectionIndex = index;
    MapStoreModule.findMainSlide(index);
  }
  private calcPositionInReverseForLastPage(collection: any): void {
    this.collectionIndex = collection.length;
    this.min = collection.length - (collection.length % 4);
    this.max = this.min + 4;
    this.active = this.collectionIndex - this.min;
    this.collectionIndex -= 1;
    //console.log('Max', this.max)
    //console.log('ret min',this.collectionIndex, this.min, this.collectionIndex);
  }
  private calcPositionInReverseForPreviousPage(collection: any): void {
    this.min = this.min - this.maxScreenCollection(collection);
    this.max = this.max - this.maxScreenCollection(collection);
    this.active = this.min;
    if (!this.manual) {
      MapStoreModule.findMainSlide(this.collectionIndex);
    }
    //console.log('ret collect0', this.min, this.max)
  }
  private calcPositionForNextPage(): void {
    if (!this.manual) {
      MapStoreModule.findMainSlide(this.collectionIndex);
    }
    //console.log('ret collect1')
    this.active = this.collectionIndex - this.min;
  }
  private calcPositionForFirstPageInLastPage(): void {
    this.collectionIndex = 0;
    this.min = 0;
    this.max = 0;
    this.active = 0;
    if (!this.manual) {
      MapStoreModule.findMainSlide(this.collectionIndex);
    }
    //console.log('ret collect2')
  }
  private recalcPositionsInCollection(collection: any) {
    this.min = this.collectionIndex;
    this.max = this.maxScreenCollection(collection) - this.collectionIndex;
    if (
      this.collectionIndex + this.maxScreenCollection(collection) >=
      this.maxScreenCollection(collection)
    ) {
      this.max = this.collectionIndex + this.maxScreenCollection(collection);
    }
    this.active = this.collectionIndex - this.min;
    if (!this.manual) {
      MapStoreModule.findMainSlide(this.collectionIndex);
    }
  }
}
